import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Mapa da aba Localização. O legado usava Google Maps com um marcador
// arrastável que preenchia latitude/longitude (chave de API exposta no HTML).
// Aqui: Leaflet + OpenStreetMap (sem chave, sem cobrança) — clicar no mapa ou
// arrastar o marcador continua preenchendo as coordenadas.

// O bundler quebra a resolução automática dos ícones do Leaflet: aponta pro CDN.
const icone = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

// Centro padrão do legado (Piracicaba/SP) quando o imóvel ainda não tem coordenadas.
const CENTRO_PADRAO = [-22.5837903, -47.4097539];

export default function MapaLeaflet({ latitude, longitude, aoMudar }) {
  const divRef = useRef(null);
  const mapaRef = useRef(null);
  const marcadorRef = useRef(null);
  const aoMudarRef = useRef(aoMudar);
  aoMudarRef.current = aoMudar;

  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);
  const temPonto = Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0);

  // cria o mapa uma vez
  useEffect(() => {
    const inicio = temPonto ? [lat, lng] : CENTRO_PADRAO;
    const mapa = L.map(divRef.current).setView(inicio, temPonto ? 17 : 13);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap',
    }).addTo(mapa);

    const marcador = L.marker(inicio, { draggable: true, icon: icone });
    if (temPonto) marcador.addTo(mapa);
    marcador.on('dragend', () => {
      const p = marcador.getLatLng();
      aoMudarRef.current(String(p.lat), String(p.lng));
    });
    mapa.on('click', (e) => {
      marcador.setLatLng(e.latlng).addTo(mapa);
      aoMudarRef.current(String(e.latlng.lat), String(e.latlng.lng));
    });

    mapaRef.current = mapa;
    marcadorRef.current = marcador;
    // a aba nasce escondida: o Leaflet precisa recalcular o tamanho quando ela aparece
    const observador = new ResizeObserver(() => mapa.invalidateSize());
    observador.observe(divRef.current);
    return () => {
      observador.disconnect();
      mapa.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // coordenadas mudaram de fora (CEP/busca de endereço/edição manual): reposiciona
  useEffect(() => {
    const mapa = mapaRef.current;
    const marcador = marcadorRef.current;
    if (!mapa || !marcador || !temPonto) return;
    const atual = marcador.getLatLng();
    if (Math.abs(atual.lat - lat) > 1e-9 || Math.abs(atual.lng - lng) > 1e-9 || !mapa.hasLayer(marcador)) {
      marcador.setLatLng([lat, lng]).addTo(mapa);
      mapa.setView([lat, lng], Math.max(mapa.getZoom(), 16));
    }
  }, [lat, lng, temPonto]);

  return <div ref={divRef} style={{ height: 320, width: '100%', borderRadius: 6 }} />;
}
